import { Chip } from "@mui/material";
import { makeStyles, useTheme } from "@mui/styles";
import React from "react";
import { getChipVariant } from '../../../utils/chipStyles';

const useStyles = makeStyles((theme) => ({
  title: {
    flexGrow: 1,
  },
  percentDif: {
    textAlign: "right",
    color: theme.palette.success.main,
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: theme.palette.common.white,
  },
  loadingIcon: {
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
  },
  billingWizardContent: {
    maxHeight: "60%",
  },
  paper: {
    padding: "1%",
  },
}));

const MissingTypeIDValue = "Unknown";

// Generic Tag Item
// NOTE:  Expects (In props){type (the name in the store as a string), isLoading, typeId, customStyles(optional), condensed(optional, uses small styling), showTitle(optional, toggles title)}
const StatusTag = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  
  // Default Values for status settings
  var isLoading = false;
  var showTitle = true;
  var condensed = false;
  if (typeof props.isLoading === "boolean") {
    isLoading = props.isLoading;
  }
  if (typeof props.showTitle === "boolean") {
    showTitle = props.showTitle;
  }
  if (typeof props.condensed === "boolean") {
    condensed = props.condensed;
  }

  // Use theme-based chip styling
  const chipVariant = getChipVariant(props.color || 'primary', theme);
  
  var chipStyles = { fontSize: "100%", fontWeight: "bolder" };
  if (props.customStyles) {
    chipStyles = Object.assign({}, props.customStyles, chipStyles);
  }
  
  // Merge custom styles with theme styles
  const finalStyle = { ...chipVariant.style, ...chipStyles };
  
  return (
    <Chip
      label={props.title}
      variant={chipVariant.variant}
      style={finalStyle}
      size={condensed ? "small" : "medium"}
    />
  );
};
export default StatusTag;
